<template>
  <div class="kpi cx-card-height">
    <head-text  :kpi="Primary" 
                :isSmall="isSmall"
                :fallbackText="fallbackText">
    </head-text>

    <item :thresholdData="thresholdData" 
          :round="true" 
          :isSmall="isSmall"
          :kpi="Primary">
    </item>
    <slot></slot>
  </div>
</template>

<script>
import HeadText from './KpiHeader.vue';
import Item from './KpiItem.vue';

export default {
  props: {
    actualTimeSetting: String,
    fallbackText: String,
    primaryKpi: Object,
    primaryKpiYTD: Object,
    secondaryKpi: Object,
    secondaryKpiYTD: Object,
    showBowl: Boolean,
    thresholdData: Array,
    isSmall: { type: Boolean, default: false }
  },

  components: {
    HeadText, Item
  },
   
  computed: {
    Primary() {
      return this.actualTimeSetting == 'current'
        ? this.primaryKpi
        : this.primaryKpiYTD;
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "@/../scss/bmw/cx.scss";
</style>
